export const STATUS_CODE = {
  TOO_MANY_CODE_REQUEST_SENT: 429,
  UNAUTHORIZED: 401,
  SUCCESS: 200
};

export const API_STATUS_MESSAGE = {
  EMAIL_EXISTS: 'Email address exists'
};
